import { HTTP } from "./http-common";

const API = {
  updateContactsAndVisaRequirements(
    contacts,
    visaRequirements,
    passports,
    workflowTrigger = true,
  ) {
    console.log(
      "[API updateContactsAndVisaRequirements] contacts, visaRequirements, passports:",
      contacts,
      visaRequirements,
      passports,
    );

    const postData = {};
    if (contacts && contacts.length) {
      postData.contacts = contacts;
    }

    if (visaRequirements && visaRequirements.length) {
      postData.visaRequirements = visaRequirements;
    }

    if (passports && passports.length) {
      postData.passports = passports;
    }

    postData.workflowTrigger = workflowTrigger; // backend uses this to toggle Zoho workflow triggers

    return HTTP.put(`/contact-and-visa-requirement`, postData)
      .then((response) => response.data)
      .catch((error) => {
        let message =
          "[CI1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.";

        if (error.response && error.response.data) {
          const isZohoError =
            error.response.data.data &&
            error.response.data.data.isZohoAPI &&
            error.response.data.data.zohoResponse;

          if (isZohoError) {
            let zohoResponse = error.response.data.data.zohoResponse.data;
            let errFieldName = zohoResponse[0].details.api_name.replaceAll(
              "_",
              " ",
            );

            if (errFieldName) {
              message =
                "[ " + errFieldName + "] You have entered an invalid data.";
            }
          } else {
            message = error.response.data.message || error.response.data.error;
          }
        }

        throw {
          ...error,
          message: message,
        };
      });
  },
  updateContactsAndBooking(
    contacts,
    booking,
    contactBookings,
    workflowTrigger = true,
  ) {
    console.log(
      "[API updateContactsAndBooking] contacts, booking, contactBookings:",
      contacts,
      booking,
      contactBookings,
    );

    const postData = {};
    if (contacts && contacts.length) {
      postData.contacts = contacts;
    }

    if (booking) {
      postData.booking = booking;
    }

    if (contactBookings && contactBookings.length) {
      postData.contactBookings = contactBookings;
    }

    postData.workflowTrigger = workflowTrigger; // backend mirrors this to Zoho to toggle workflows

    return HTTP.put(`/contact-and-booking`, postData)
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CI2] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
  updatePrePostArrangements(prePostArrangements) {
    return HTTP.put(`/pre-post-arrangement`, {
      prePostArrangements,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CI3] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
  logout() {
    return HTTP.post("/logout")
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CI4] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
  refreshAccessToken() {
    return HTTP.post("/refresh")
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CI5] Oops! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
};

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js